import { Utils } from "./Utils";

/**
 * Utilidades para exibição de edições e outras coisas mais.
 */
export class EditionUtils {
  /**
   * Lista com nomes de meses abreviados.
   * 
   * @type {String[]}
   */
  static MONTH_ABBR = [
    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
  ];

  /**
   * Lista com nomes de meses.
   * 
   * @type {String[]}
   */
  static MONTH_FULL = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  /**
   * Retorna o editionId para o feedback mais recente possível.
   * 
   * @param {Boolean} isSuperbox 
   *     Se superbox ou não 
   * @returns {String}
   */
  static getEditionFeedbackId (isSuperbox = false) {
    let date = new Date(),
        month,
        year,
        subscriptionType = (isSuperbox === true) ? 2 : 1;
    
    year = (date.getMonth() === 0) 
      ? date.getFullYear() - 1 
      : date.getFullYear();
    year = Utils.pad(year, 4);

    month = (date.getMonth() === 0) 
      ? 12 
      : date.getMonth();
    month = Utils.pad(month, 2);

    return `${subscriptionType}${year}${month}`;
  }

  /**
   * Retorna a data da edição para o editionId fornecido.
   * 
   * @param {String|Number} editionId 
   *     ID da edição de Glambox/Superbox
   * @param {Boolean} abbr 
   *     Se o nome do mês deve ser abreviado, ou não 
   * @param {String} separator 
   *     Separador para mês/ano, padrão ", "
   */
  static getEditionDateName (
    editionId, 
    abbr = false,
    separator = ", "
  ) {
    let ano = parseInt(editionId / 100 % 10000, 10), 
        mes = parseInt(editionId % 100, 10);
    
    return (abbr === true) 
      ? EditionUtils.MONTH_ABBR[mes - 1] + separator + ano 
      : EditionUtils.MONTH_FULL[mes - 1] + separator + ano;
  }

  /**
   * 
   * @param {String|Number} editionId 
   * @param {*} isManuallyReceivedEdition 
   * @param {*} editionStatusId 
   */
  static getTrackingStatus (
    editionId,
    isManuallyReceivedEdition,
    editionStatusId
  ) {
    let title,
        id;

    if (
      editionId < 1201712 
      || (editionId < 2201801 && editionId > 2201202) 
      || isManuallyReceivedEdition
    ) {
      id = "entregue";
      title = "Entregue";
    } else {
      switch (editionStatusId) {
        case -1: // REMOVIDA/ESTORNADA
        case 0:
        case 9: // TESTE
        case 1:
          id = "confirmado";
          title = "Confirmado";
          break;       
        case 2:
          id = "montagem";
          title = "Montagem";
          break;
        case 3:
        case 4:
          id = "coletada";
          title = "Retirada pela transportadora";
          break;
        case 5:
          id = "emrota";
          title = "Em Rota";
          break;
        case 6:
          id = "entregue";
          title = "Entregue";
          break;
        default:
          id = "emrota";
          title = "Em Rota";
          break;
      }

      return { id, title };
    }

    return {
      title,
      id
    };
  }

  static getCurrentEditionId () {

    let today = new Date();
    let month = today.getMonth()+1;
    month = month.toString();

    if (month.length < 2) {
      month = `0${month}`
    }

    let year = today.getFullYear().toString();

    let currentEdition = `1${year}${month}`

    return parseInt(currentEdition, 10);
  }


  static getPreviousEditionId () {

    let today = new Date();
    today.setMonth(today.getMonth()-1);

    let month = today.getMonth()+1;
    month = month.toString();

    if (month.length < 2) {
      month = `0${month}`
    }

    let year = today.getFullYear().toString();

    let lastEdition = `1${year}${month}`

    return parseInt(lastEdition, 10);
  }

}
